import axios from "axios";
import app from "../App.jsx";

class Api {
  static getOktaLoginURL(authRequest) {
    let result = doPost(
      `${window.appConfig.msLoginBaseUrl}/login/auth/url`,
      authRequest
    );
    return result;
  }

  static getLoginAs(authRequest) {
    return doPost(
      `${window.appConfig.msLoginBaseUrl}/login/auth/login-as`,
      authRequest
    );
  }

  //create a CB login session after successfully authenticated by okta and exchange the token
  static getSSOSession(request) {
    return doPost(
      `${window.appConfig.msLoginBaseUrl}/login/auth/exchange`,
      request
    );
  }

/*    static checkMismatchLogin = async (request) =>{
        return doPost(
            `${window.appConfig.msLoginBaseUrl}/login/auth/checkMismatchLogin`,
            request
        );
    }*/

    //get existing login session
    static getUnifiedSession = async (unifiedSessionId, appId) =>{
        return doGet(
            `${window.appConfig.msLoginBaseUrl}/login/auth/unifiedSession?unifiedSessionId=${unifiedSessionId}&appId=${appId}`
        );
    }

    static getIdp = async (appId) =>{
        return doGet(
            `${window.appConfig.msLoginBaseUrl}/login/auth/idp?appId=${appId}`
        );
    }

  static deleteAllOktaSessions = async (isCsrSession) => {
    let yourOktaDomain = `${window.appConfig.oktaEnv}.idp.collegeboard.org`;
    let oktaPortalDomain = (window.appConfig.oktaEnv==='prod') ? 'collegeboard.okta.com' : `collegeboard-${window.appConfig.oktaEnv}.oktapreview.com`;
    let oktaDomainUrl = [yourOktaDomain];
    if (isCsrSession){
      oktaDomainUrl.push(oktaPortalDomain);
    } 
    
    try {
      for (const oktaDomain of oktaDomainUrl) {
        let serviceEndpointPrefix = `https://${oktaDomain}/api/`;
        await Api.deleteOktaSession(serviceEndpointPrefix);
      }
    } catch (error) {
      console.error("Error occurred when deleting okta sessions!");
      if (error) console.error(error);
    }
  };

  static deleteOktaSession = async (serviceEndpointPrefix) => {
    const endpoint = serviceEndpointPrefix + `v1/sessions/me`;

    try {
      const response = await axios.delete(endpoint, { withCredentials: true });
    } catch (error) {
      if (error.response.status === 404) {
        console.log("------No active okta session to kill");
      } else {
        console.log("------error in deleting okta session", error);
      }
    }
  };

  static sendAuthError = async (error) => {
    return doPost(`${window.appConfig.msLoginBaseUrl}/login/auth/error`, error);
  };

  static logout = async (logOutRequest) => {
    return doPost(
      `${window.appConfig.msLoginBaseUrl}/login/logout`,
      logOutRequest
    );
  };

    static async getSignupUrl(idp, appId, DURL) {
        const url = new URL(`${window.appConfig.msLoginBaseUrl}/login/auth/signupUrl`);
        if (idp){
            url.searchParams.append('idp', idp);
        }
        if (appId){
            url.searchParams.append('appId', appId);
        }
        if (DURL){
            url.searchParams.append('destinationUrl', DURL);
        }
        return doGet(
            url.toString(),
        );
    }
}

/**
 * Executes HTTP get request
 * @param url the request URL.
 * @param id_token the token
 * @returns {Promise<Object>} a promise containing the service response object.
 */
async function doGet(url) {
  return axios
    .get(url, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("axios get error: ", error);
      throw error;
    });
}

async function doPost(url, request) {
  return axios({
    url: url,
    method: "post",
    data: request,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

export default Api;
